module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg6.83d62f73.png";